<template>
  <div class=" container full-height">
    <div class="angeboteCreate full-height">
      <h1 v-if="this.step != 13 && this.step != 14">{{$t('Angebot.Edit')}}</h1>

      <form @submit.prevent class="full-height" v-if="this.step != 13 && this.step != 14"> 
        <!-- Stepers Wrapper -->
          <div class="step-wrapper full-height">
            <div class="step step-1" v-if="step == 1">
              <h2>{{$t('Angebot.Infos')}}</h2>
              <p class="font-red text-left" v-if="showRequiredError == true && requiredErrorMessage  == 1">
                {{$t('Angebot.Error01')}}
              </p>
              <p class="font-red text-left" v-if="showRequiredError == true && requiredErrorMessage  == 2">
                {{$t('Angebot.Error02')}}
              </p>
              <p class="font-red text-left" v-if="showRequiredError == true && requiredErrorMessage  == 3">
                {{$t('Angebot.Error03')}}
              </p>
              <p class="font-red text-left" v-if="showRequiredError == true && requiredErrorMessage  == 4">
                {{$t('Angebot.Error04')}}
              </p>

                <div class="md-form row">
                  <div class="col-6">
                      
                      <mdb-input :label="$t('Angebot.Name')"v-model="Angebot.name" />
                  </div>
                  <div class="col-6 d-flex align-items-center justify-content-center">
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="nameAnzeigen" name="nameAnzeigen" v-model="Angebot.showname">
                        <label class="form-check-label" for="nameAnzeigen">{{$t('Angebot.Anzeige')}}</label>
                      </div>
                  </div>
                </div>

                <div class="md-form row">
                  <div class="col-6">
                    
                  <mdb-input :label="$t('Angebot.Tele')" v-model="Angebot.telefon" />
                  </div>
                  <div class="col-6 d-flex align-items-center justify-content-center">
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="teleAnzeigen" name="telAnzeigen" v-model="Angebot.showtelefon">
                        <label class="form-check-label" for="teleAnzeigen">{{$t('Angebot.Anzeige')}}</label>
                      </div>
                  </div>
                </div>
                <div class="md-form row">
                  <div class="col-6">
                    
                    <mdb-input :label="$t('Angebot.Handy')" v-model="Angebot.mobil" />
                  </div>
                  <div class="col-6 d-flex align-items-center justify-content-center">
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="handyAnzeigen" name="handyAnzeigen" v-model="Angebot.showmobil">
                        <label class="form-check-label" for="handyAnzeigen">{{$t('Angebot.Anzeige')}}</label>
                      </div>
                  </div>
                </div>
                <div class="md-form row">
                  <div class="col-6">
                    
                     <mdb-input type="email" :label="$t('Angebot.Email')" v-model="Angebot.email" />
                  </div>
                  <!--<div class="col-6 d-flex align-items-center justify-content-center">
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="emailAnzeigen" name="emailAnzeigen" v-model="Angebot.showemail">
                        <label class="form-check-label" for="emailAnzeigen">{{$t('Angebot.Anzeige')}}</label>
                      </div>
                  </div>-->
                </div>
            </div>

            <div class="step step-2" v-if="step == 2">
              <h2>{{$t('Angebot.Allgemein')}}</h2>
              <mdb-select v-model="arten" @change="changeZimmerart($event)" :label="$t('Angebot.Zimmerart')" placeholder="Wählen Sie die Zimmerart" ></mdb-select>


              <div class="md-form">
                  
                  <mdb-input type="number" :label="$t('Angebot.Groeße')" v-model="Angebot.zimmergroesse" />
                </div>
                <div class="md-form">
                  <mdb-date-picker v-model="Angebot.freiab" :option="option" :label="$t('Angebot.Datumfrei')" />

                </div>
                <div class="md-form">
                  <mdb-date-picker v-model="Angebot.freibis" :option="option" :label="$t('Angebot.Datumbis')" />

                </div>
                <div class="md-form">
              
                  <mdb-input :label="$t('Angebot.Mindauer')" v-model="Angebot.minimalemietdauer" />
                </div>
            </div>


            <div class="step step-3" v-if="step == 3">
              <h2>{{$t('Angebot.Kosten')}}</h2>
                <!-- Material input -->
                <div class="md-form">
                  
                   <mdb-input type="number" :label="$t('Angebot.Miete')"  v-model="Angebot.miete" />
                </div>
                <div class="md-form">
                 
                   <mdb-input type="number" :label="$t('Angebot.Nebenkosten')" v-model="Angebot.nebenkosten" />
                </div>
              <mdb-select v-model="nebenkostenArten" placeholder="Nebenkostenart auswählen" @change="changeNebenkostenart($event)" :label="$t('Angebot.Nebenkostenart')"/>


              <div class="md-form">
                  <mdb-input type="number" :label="$t('Angebot.Kaution')" v-model="Angebot.kaution" />
                  
                </div>
            </div>

            <div class="step step-4" v-if="step == 4">
              <h2 class="mb-5">{{$t('Angebot.Personenkreis')}}</h2>
              <div class="row mb-5">
                  <div class="col-3 text-left">
                      <label>{{$t('Angebot.Geschlecht')}}</label>
                  </div>
                  <div class="col-9">
                    <div class="d-flex align-items-start flex-column">

                      <mdb-input type="radio" id="mietergeschlecht-1" name="mietergeschlecht" radioValue="e" v-model="Angebot.mietergeschlecht" :label="$t('Angebot.Geschlechts.Egal')" />
                      <mdb-input type="radio" id="mietergeschlecht-2" name="mietergeschlecht" radioValue="w" v-model="Angebot.mietergeschlecht" :label="$t('Angebot.Geschlechts.Weiblich')" />
                      <mdb-input type="radio" id="mietergeschlecht-3" name="mietergeschlecht" radioValue="m" v-model="Angebot.mietergeschlecht" :label="$t('Angebot.Geschlechts.Maennlich')" />
                      
                        </div>
                      </div>
                </div>
                <div class="row mb-5">
                  <div class="col-3 text-left">
                      <label>{{$t('Angebot.Raucher')}}</label>
                  </div>
                  <div class="col-9">
                    <div class="d-flex align-items-start flex-column">
                      <mdb-input type="radio" id="mieterraucher-1" name="mieterraucher" radioValue="1" v-model="Angebot.mieterraucher" :label="$t('Global.Ja')" />
                      <mdb-input type="radio" id="mieterraucher-2" name="mieterraucher" radioValue="0" v-model="Angebot.mieterraucher" :label="$t('Global.Nein')" />
                    </div>
                  </div>
                </div>
                <div class="row mb-5">
                  <div class="col-3 text-left">
                      <label>{{$t('Angebot.Bevorzugt')}}</label>
                  </div>
                  <div class="col-9">
                    <div class="d-flex align-items-start flex-column">
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="bevorzugt-1" name="bevorzugt" v-model="Angebot.mieterbevorzugt" value="student">
                        <label class="form-check-label" for="bevorzugt-1">{{$t('Angebot.Bevorzugte.Student')}}</label>
                      </div>
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="bevorzugt-2" name="bevorzugt" v-model="Angebot.mieterbevorzugt" value="doktor">
                        <label class="form-check-label" for="bevorzugt-2">{{$t('Angebot.Bevorzugte.Doktor')}}</label>
                      </div>
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="bevorzugt-3" name="bevorzugt" v-model="Angebot.mieterbevorzugt" value="postdoc">
                        <label class="form-check-label" for="bevorzugt-3">{{$t('Angebot.Bevorzugte.Postdoc')}}</label>
                      </div>
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="bevorzugt-4" name="bevorzugt" v-model="Angebot.mieterbevorzugt" value="gast">
                        <label class="form-check-label" for="bevorzugt-4">{{$t('Angebot.Bevorzugte.Gastwissenschaftler')}}</label>
                      </div>
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="bevorzugt-5" name="bevorzugt" v-model="Angebot.mieterbevorzugt" value="beschaeftigt">
                        <label class="form-check-label" for="bevorzugt-5">{{$t('Angebot.Bevorzugte.Beschaeftigt')}}</label>
                      </div>
            
                    </div>
                  </div>
                </div>
                
            </div>

            <div class="step step-5" v-if="Angebot.art === 'wohngemeinschaft' && step == 5">
              <h2>{{$t('Angebot.Wg')}}</h2>
              <mdb-input :label="$t('Angebot.Wggroeße')" v-model="Angebot.wggroesse" />
              <mdb-input :label="$t('Angebot.Wganzahlm')" v-model="Angebot.wgmitbewohnerm" />
              <mdb-input :label="$t('Angebot.Wganzahlw')" v-model="Angebot.wgmitbewohnerw" />
            </div>

            <div class="step step-6" v-if="step == 6">
              <h2 class="mb-5">{{$t('Angebot.Ausstattungkueche')}}</h2>
                <div class="row mb-5">
                  <div class="col-3 text-left">
                      <label>{{$t('Angebot.Ausstattungkueche')}}</label>
                  </div>
                  <div class="col-9">
                    <div class="row">
                      <div class="col-6">
                        <div class="d-flex align-items-start flex-column">
                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="kuchenAusstattung-1" name="kuechenAusstattung" v-model="Angebot.ausstattungkueche" value="mitbenutzung">
                            <label class="form-check-label" for="kuchenAusstattung-1">{{$t('Angebot.Ausstattungkueches.Mitbenutzung')}}</label>
                          </div>
                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="kuchenAusstattung-2" name="kuechenAusstattung" v-model="Angebot.ausstattungkueche" value="backofen">
                            <label class="form-check-label" for="kuchenAusstattung-2">{{$t('Angebot.Ausstattungkueches.Backofen')}}</label>
                          </div>
                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="kuchenAusstattung-3" name="kuechenAusstattung" v-model="Angebot.ausstattungkueche" value="herd">
                            <label class="form-check-label" for="kuchenAusstattung-3">{{$t('Angebot.Ausstattungkueches.Herd')}}</label>
                          </div>
                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="kuchenAusstattung-4" name="kuechenAusstattung" v-model="Angebot.ausstattungkueche" value="spuelmaschine">
                            <label class="form-check-label" for="kuchenAusstattung-4">{{$t('Angebot.Ausstattungkueches.Spuelmaschine')}}</label>
                          </div>

                    </div>
                      </div>
                      <div class="col-6">
                      <div class="d-flex align-items-start flex-column">
                        <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="kuchenAusstattung-5" name="kuechenAusstattung" v-model="Angebot.ausstattungkueche" value="kuehlschrank">
                            <label class="form-check-label" for="kuchenAusstattung-5">{{$t('Angebot.Ausstattungkueches.Kuehlschrank')}}</label>
                        </div>
                        <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="kuchenAusstattung-6" name="kuechenAusstattung" v-model="Angebot.ausstattungkueche" value="mikrowelle">
                            <label class="form-check-label" for="kuchenAusstattung-6">{{$t('Angebot.Ausstattungkueches.Mikrowelle')}}</label>
                        </div>
                        <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="kuchenAusstattung-7" name="kuechenAusstattung" v-model="Angebot.ausstattungkueche" value="geschirr">
                            <label class="form-check-label" for="kuchenAusstattung-7">{{$t('Angebot.Ausstattungkueches.Geschirr')}}</label>
                        </div>
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" id="kuchenAusstattung-8" name="kuechenAusstattung" v-model="Angebot.ausstattungkueche" value="eigene">
                          <label class="form-check-label" for="kuchenAusstattung-8">{{$t('Angebot.Ausstattungkueches.Eigene')}}</label>
                        </div>
   
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>
                
            </div>

            <div class="step step-7" v-if="step == 7">
              <h2 class="mb-5">{{$t('Angebot.Ausstattungbad')}}</h2>
                <div class="row mb-5">
                  <div class="col-3 text-left">
                      <label>{{$t('Angebot.Ausstattungbad')}}</label>
                  </div>
                  <div class="col-9">
                    <div class="row">
                      <div class="col-6">
                        <div class="d-flex align-items-start flex-column">

                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="badAusstattung1" name="badAusstattung1" value="mitbenutzung" v-model="Angebot.ausstattungbad">
                            <label class="form-check-label" for="badAusstattung1">{{$t('Angebot.Ausstattungbads.Mitbenutzung')}}</label>
                          </div>
                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="badAusstattung2" name="badAusstattung2" value="wc" v-model="Angebot.ausstattungbad">
                            <label class="form-check-label" for="badAusstattung2">{{$t('Angebot.Ausstattungbads.Wc')}}</label>
                          </div>
                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="badAusstattung3" name="badAusstattung3" value="dusche" v-model="Angebot.ausstattungbad">
                            <label class="form-check-label" for="badAusstattung3">{{$t('Angebot.Ausstattungbads.Dusche')}}</label>
                          </div>

                        </div>
                      </div>
                      <div class="col-6">
                      <div class="d-flex align-items-start flex-column">

                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="badAusstattung5" name="badAusstattung4" value="badewanne" v-model="Angebot.ausstattungbad">
                            <label class="form-check-label" for="badAusstattung5">{{$t('Angebot.Ausstattungbads.Badewanne')}}</label>
                          </div>
                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="badAusstattung6" name="badAusstattung5" value="gaesteWc" v-model="Angebot.ausstattungbad">
                            <label class="form-check-label" for="badAusstattung6">{{$t('Angebot.Ausstattungbads.Gaestewc')}}</label>
                          </div>
                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="badAusstattung7" name="badAusstattung6" value="eigenesBad" v-model="Angebot.ausstattungbad">
                            <label class="form-check-label" for="badAusstattung7">{{$t('Angebot.Ausstattungbads.Eigenesbad')}}</label>
                          </div>

                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>
                
            </div>

            <div class="step step-8" v-if="step == 8">
              <h2 class="mb-5">{{$t('Angebot.Ausstattungsonstige')}}</h2>
              <div class="row mb-5">
                <div class="col-12">
                  <mdb-select v-model="internetListe" @change="changeInternet" :label="$t('Angebot.Internet')" placeholder="Auswählen"></mdb-select>

                </div>
              </div>

              <div class="row mb-5">
                <div class="col-12">
                  <mdb-select v-model="telefonListe" @change="changeTelefon($event)" :label="$t('Angebot.Telefon')" placeholder="Auswählen"></mdb-select>
                </div>
              </div>
          
                <div class="row mb-5">
                  <div class="col-3 text-left">
                      <label>{{$t('Angebot.Ausstattungsonstige')}}</label>
                  </div>
                  <div class="col-9">
                    <div class="row">
                      <div class="col-6">
                          <div class="d-flex align-items-start flex-column">

                            <div class="form-check">
                              <input type="checkbox" class="form-check-input" id="ausstattung1" name="ausstattung1" value="tv" v-model="Angebot.ausstattungsonstiges">
                              <label class="form-check-label" for="ausstattung1">{{$t('Angebot.Ausstattungsonstiges.Tv')}}</label>
                            </div>
                            <div class="form-check">
                              <input type="checkbox" class="form-check-input" id="ausstattung2" name="ausstattung2" value="balkon" v-model="Angebot.ausstattungsonstiges">
                              <label class="form-check-label" for="ausstattung2">{{$t('Angebot.Ausstattungsonstiges.Balkon')}}</label>
                            </div>
                            <div class="form-check">
                              <input type="checkbox" class="form-check-input" id="ausstattung3" name="ausstattung3" value="terasse" v-model="Angebot.ausstattungsonstiges">
                              <label class="form-check-label" for="ausstattung3">{{$t('Angebot.Ausstattungsonstiges.Terasse')}}</label>
                            </div>
                            <div class="form-check">
                              <input type="checkbox" class="form-check-input" id="ausstattung4" name="ausstattung4" value="stellplatz" v-model="Angebot.ausstattungsonstiges">
                              <label class="form-check-label" for="ausstattung4">{{$t('Angebot.Ausstattungsonstiges.Stellplatz')}}</label>
                            </div>
                            <div class="form-check">
                              <input type="checkbox" class="form-check-input" id="ausstattung5" name="ausstattung5" value="waschmaschine" v-model="Angebot.ausstattungsonstiges">
                              <label class="form-check-label" for="ausstattung5">{{$t('Angebot.Ausstattungsonstiges.Waschmaschine')}}</label>
                            </div>
                            <div class="form-check">
                              <input type="checkbox" class="form-check-input" id="ausstattung6" name="ausstattung6" value="waschmaschineMitbenutzung" v-model="Angebot.ausstattungsonstiges">
                              <label class="form-check-label" for="ausstattung6">{{$t('Angebot.Ausstattungsonstiges.Waschmaschinemit')}}</label>
                            </div>
                            <div class="form-check">
                              <input type="checkbox" class="form-check-input" id="ausstattung7" name="ausstattung7" value="trockner" v-model="Angebot.ausstattungsonstiges">
                              <label class="form-check-label" for="ausstattung7">{{$t('Angebot.Ausstattungsonstiges.Trockner')}}</label>
                            </div>
                            <div class="form-check">
                              <input type="checkbox" class="form-check-input" id="ausstattung8" name="ausstattung8" value="trocknerMitbenutzung" v-model="Angebot.ausstattungsonstiges">
                              <label class="form-check-label" for="ausstattung8">{{$t('Angebot.Ausstattungsonstiges.Trocknermit')}}</label>
                            </div>
                          </div>
                      </div>
                      <div class="col-6">
                          <div class="d-flex align-items-start flex-column">
                            <div class="form-check">
                              <input type="checkbox" class="form-check-input" id="ausstattung9" name="ausstattung9" value="bettwaesche" v-model="Angebot.ausstattungsonstiges">
                              <label class="form-check-label" for="ausstattung9">{{$t('Angebot.Ausstattungsonstiges.Bettwaesche')}}</label>
                            </div>

                            <div class="form-check">
                              <input type="checkbox" class="form-check-input" id="ausstattung10" name="ausstattung10" value="haustiere" v-model="Angebot.ausstattungsonstiges">
                              <label class="form-check-label" for="ausstattung10">{{$t('Angebot.Ausstattungsonstiges.Haustier')}}</label>
                            </div>
                            <div class="form-check">
                              <input type="checkbox" class="form-check-input" id="ausstattung11" name="ausstattung11" value="behindert" v-model="Angebot.ausstattungsonstiges">
                              <label class="form-check-label" for="ausstattung11">{{$t('Angebot.Ausstattungsonstiges.Behindertengerecht')}}</label>
                            </div>
                            <div class="form-check">
                              <input type="checkbox" class="form-check-input" id="ausstattung12" name="ausstattung12" value="allergiker" v-model="Angebot.ausstattungsonstiges">
                              <label class="form-check-label" for="ausstattung12">{{$t('Angebot.Ausstattungsonstiges.Allergikergerecht')}}</label>
                            </div>
                            <div class="form-check">
                              <input type="checkbox" class="form-check-input" id="ausstattung13" name="ausstattung13" value="moebeliert" v-model="Angebot.ausstattungsonstiges">
                              <label class="form-check-label" for="ausstattung13">{{$t('Angebot.Ausstattungsonstiges.Moebliert')}}</label>
                            </div>
                          </div>
                      </div>
                    </div>
                   
                </div>
                </div>
            </div>

            <div class="step step-9" v-if="step == 9">
              <h2>{{$t('Angebot.Lage')}}</h2>
                

                 <mdb-input :label="$t('Angebot.Plz')" v-model="Angebot.plz" />

              <mdb-select v-model="listOrte" @change="changeListOrte($event)" label="Ort auswählen" placeholder="Ort auswählen" :searchPlaceholder="$t('Suche.Suche')" :resultText="$t('Suche.KeineErgebnisse')"></mdb-select>
              <p class="small text-left">{{$t('Angebot.OrtaddInfo')}}</p>

                <mdb-input :label="$t('Angebot.Straße')" v-model="Angebot.strasse" />
                 <mdb-input :label="$t('Angebot.Hausnummer')" v-model="Angebot.hausnummer" />
                

                <div class="row mb-5">
                  <div class="col-3 text-left">
                      <label>{{$t('Angebot.Etage')}}</label>
                  </div>
                  <div class="col-9">
                    <div class="row">
                      <div class="col-6">
                        <div class="d-flex align-items-start flex-column">
                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="etage1" name="etage1" value="erdgeschoss" v-model="Angebot.etage">
                            <label class="form-check-label" for="etage1">{{$t('Angebot.Etages.Erdgeschoss')}}</label>
                          </div>
                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="etage2" name="etage2" value="stockwerk" v-model="Angebot.etage">
                            <label class="form-check-label" for="etage2">{{$t('Angebot.Etages.Stockwerk')}}</label>
                          </div>
                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="etage3" name="etage3" value="dachgeschoss" v-model="Angebot.etage">
                            <label class="form-check-label" for="etage3">{{$t('Angebot.Etages.Dachgeschoss')}}</label>
                          </div>

                        </div>
                      </div>
                      <div class="col-6">
                      <div class="d-flex align-items-start flex-column">
                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="etage5" name="etage4" value="maisonette" v-model="Angebot.etage">
                            <label class="form-check-label" for="etage5">{{$t('Angebot.Etages.Maisonette')}}</label>
                          </div>
                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="etage6" name="etage5" value="souterrain" v-model="Angebot.etage">
                            <label class="form-check-label" for="etage6">{{$t('Angebot.Etages.Souterrain')}}</label>
                          </div>
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" id="lift" name="lift" value="1" v-model="Angebot.lift">
                          <label class="form-check-label" for="lift">{{$t('Angebot.Etages.Lift')}}</label>
                        </div>

                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>
              <div class="row mb-5 stockwerk__row" v-bind:class="{ active: Angebot.etage == 'stockwerk' }">
                <div class="col-3 text-left">
                  <label>{{$t('Angebot.Etages.Stockwerk')}}</label>
                </div>
                <div class="col-9">
                  <div class="row">
                    <div class="col-6">
                      <div class="d-flex align-items-start flex-column">
                        <mdb-input :label="$t('Angebot.Etages.Stockwerk')" v-model="Angebot.stockwerk" />

                      </div>
                    </div>
                  </div>
                </div>
              </div>
                <div class="row mb-5">
                  <div class="col-3 text-left">
                      <label>{{$t('Angebot.Zusatz')}}</label>
                  </div>
                  <div class="col-9">
                    <div class="d-flex align-items-start flex-column">
                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="zusatz1" name="zusatz1" value="eingang" v-model="Angebot.zimmerzusatzinformationen">
                            <label class="form-check-label" for="zusatz1">{{$t('Angebot.Zusatzs.Eingang')}}</label>
                          </div>
                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="zusatz2" name="zusatz2" value="gartenmitbenutzung" v-model="Angebot.zimmerzusatzinformationen">
                            <label class="form-check-label" for="zusatz2">{{$t('Angebot.Zusatzs.Gartenmit')}}</label>
                          </div>
                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="zusatz3" name="zusatz3" value="garten" v-model="Angebot.zimmerzusatzinformationen">
                            <label class="form-check-label" for="zusatz3">{{$t('Angebot.Zusatzs.Garten')}}</label>
                          </div>

                        </div>
                  </div>
                </div>
                
            </div>

            <div class="step step-10" v-if="step == 10">
              <h2>{{$t('Angebot.Anbindung')}}</h2>
    
                <div class="row mb-5">
                  <div class="col-3 text-left">
                      <label>{{$t('Angebot.Erreichbar')}}</label>
                  </div>
                  <div class="col-9">
                    <div class="row">
                      <div class="col-6">
                        <div class="d-flex align-items-start flex-column">

                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="erreichbar1" value="bus" v-model="Angebot.verkehrsanbindung">
                            <label class="form-check-label" for="erreichbar1">{{$t('Angebot.Erreichbars.Bus')}}</label>
                          </div>
                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="erreichbar2" value="bahn" v-model="Angebot.verkehrsanbindung">
                            <label class="form-check-label" for="erreichbar2">{{$t('Angebot.Erreichbars.Bahn')}}</label>
                          </div>
                       </div>
                      </div>
                      <div class="col-6">
                      <div class="d-flex align-items-start flex-column">
                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="erreichbar3" value="sbahn" v-model="Angebot.verkehrsanbindung">
                            <label class="form-check-label" for="erreichbar3">{{$t('Angebot.Erreichbars.Sbahn')}}</label>
                          </div>
                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="erreichbar4" value="auto" v-model="Angebot.verkehrsanbindung">
                            <label class="form-check-label" for="erreichbar4">{{$t('Angebot.Erreichbars.Pkw')}}</label>
                          </div>

                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>

                <div class="row mb-5 w-100">
                   <mdb-input class="w-100" type="textarea" :placeholder="$t('Angebot.EntfernungPlaceholder')" :label="$t('Angebot.Entfernung')" :rows="5" v-model="Angebot.entfernung"/>
                </div>
                
            </div>

            <div class="step step-11" v-if="step == 11">
              <h2>{{$t('Angebot.Sonstiges')}}</h2>
                <mdb-input type="textarea" :placeholder="$t('Angebot.BemerkungPlaceholder')" :label="$t('Angebot.Bemerkung')" :rows="5" v-model="Angebot.bemerkungen"/>
            </div>
            <div class="step step-12" v-if="step == 12">
              <Slider :images="images" :maxImages="10" :maxSize="3000000"></Slider>
            </div>

          </div>
        <!-- /.Stepers Wrapper -->
        <div class="d-flex mb-5 justify-content-between align-items-center">
          
          <mdb-btn color="danger" class="mr-5" v-if="step !== 1" v-bind:class="{ active: step > 1 }"  @click.native.prevent="prev()">{{$t('Global.Vorherigeseite')}}</mdb-btn>
          <mdb-btn color="danger" class="mr-5" v-else v-bind:class="{ active: step == 1 }"   @click.native="$router.go(-1)">{{$t('Global.Zurueck')}}</mdb-btn>
          <div class="mr-5 gutter"></div>
          <div class="flex-1">
            <mdb-progress :value="(this.step/12 * 100)" />
          </div>
          <div class="mr-5 gutter"></div>
          <mdb-btn color="danger"  v-if="step !== 12" v-bind:class="{ active: step <= 11 }"    @click.native.prevent="next()">{{$t('Global.Naechsteseite')}}</mdb-btn>
          <mdb-btn color="danger" type="submit"  v-else class="" @click.native.prevent="editAngebot()">{{$t('Global.Angeboteditieren')}}</mdb-btn>

        </div>
        
        
      </form>
      <div class="step step-13 full-height d-flex justify-content-center align-items-center" v-if="step == 13">
              <h4 class="mb-5">{{$t('Angebot.DankeBearbeiten')}}</h4>
              <router-link :to="{ name: 'home'}"  class="nav-links ">
                <button type="button" class="btn btn-outline-danger waves-effect">{{$t('Angebot.Zurück')}}</button>
              </router-link>
      </div>
      <div class="step step-14 full-height d-flex justify-content-center align-items-center" v-if="step == 14">
              <h4 class="mb-5">{{$t('Angebot.Error')}}</h4>
              <router-link :to="{ name: 'home'}"  class="nav-links ">
                <button type="button" class="btn btn-outline-danger waves-effect">{{$t('Angebot.Zurück')}}</button>
              </router-link>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import AngebotService from "../../services/AngebotService.js";
import ImageService from "@/services/ImageService.js";
import EmailService from "@/services/EmailService.js";
import Upload from "@/components/MultipleFiles";
import Axios from 'axios';
import settings from '@/components/Settings.json';
import { mdbBtn, mdbInput, mdbDatePicker, mdbSelect, mdbProgress } from 'mdbvue';
import SettingService from '@/services/SettingsService';
import format from 'date-fns/format';
import VueGallery from 'vue-gallery';
import Slider from "@/components/ImageSlider";
export default {
  name: "Edit",
  components: {
    Upload,
     mdbBtn,
            mdbInput,
            mdbDatePicker,
            mdbSelect,
              mdbProgress,
    'gallery': VueGallery,
    Slider
  },
  props: ["angebotToEdit"],
  data() {
    return {
      index: null,
      Angebot: Object,
      step: 1,
      showRequiredError: false,
      requiredErrorMessage: 0,
      arten: settings.Settings[1][this.$store.getters.lang][0].Zimmerarten,
      nebenkostenArten: settings.Settings[1][this.$store.getters.lang][0].nebenkostenArten,
      orteFreiburg: [],
      orteSonstige: settings.Settings[1][this.$store.getters.lang][0].orteSonstige,
      listOrte: [],
      images: [],
      files: [],
      internetListe: settings.Settings[1][this.$store.getters.lang][0].internetListe,
      telefonListe:settings.Settings[1][this.$store.getters.lang][0].telefonListe,
      option: {
        format: 'DD.M.YYYY',
        week: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
        month: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'July', 'August', 'September', 'Oktober', 'November', 'Dezember'],
        buttons: {
          ok: 'Ok',
          cancel: 'Abbrechen',
          today: 'Heute',
          clear: 'Löschen'
        }
      }
    };
  },
  methods: {
    removeImage(i){


      if(this.images.length > 1){
        let ind = this.images.indexOf(i);
        this.images.splice(ind, 1);
        let url = this.images[ind];
        let filename = url.substring(url.lastIndexOf('/')+1);
        ImageService.deleteSingleImage(filename);
      } else {
        let url = this.images[0];
        let filename = url.substring(url.lastIndexOf('/')+1);
        this.images.splice(0, 1);
        ImageService.deleteSingleImage(filename);
      }

    },
    uploadImages(filesData){
      let allFiles = filesData;
      let fData = new FormData();
      for( var i = 0; i < filesData.length; i++ ){
        let file = filesData[i];
        let newName = this.Angebot.persistence_object_identifier + "-" + file.name;
        const newFile = new File([file], newName, {type: file.type});
        fData.append('files[' + i + ']', newFile);
        console.log("New file", newFile);
      }

      let id = this.Angebot.persistence_object_identifier;
      let _this = this;
      console.log("Fdata", fData);
      ImageService.addImages(fData).then(function(){
        console.log("Bilder wurden hochgeladen");
        _this.getImages(id);
      }).catch(function(){
        console.log("Error beim Upload der Bilder");
      });
    },
    editAngebot() {
      if(this.Angebot.freiab != null){
        this.Angebot.freiab = this.$parent.$func.formateDateForDB(this.Angebot.freiab);
      }
      if(this.Angebot.freibis != null){
        this.Angebot.freibis = this.$parent.$func.formateDateForDB(this.Angebot.freibis);
      }

      this.Angebot.showmobil = this.Angebot.showmobil === true ? 1 : 0;
      this.Angebot.showname = this.Angebot.showname === true ? 1 : 0;
      this.Angebot.showtelefon = this.Angebot.showtelefon === true ? 1 : 0;
      this.Angebot.lift = this.Angebot.lift === true ? 1 : 0;
      if(this.Angebot.entfernung) {
        this.Angebot.entfernung = this.Angebot.entfernung.replace(/['"]+/g, '');
      }
      if(this.Angebot.bemerkungen){
        this.Angebot.bemerkungen = this.Angebot.bemerkungen.replace(/['"]+/g, '');
      }

      localStorage.removeItem("angebotToEdit");
      AngebotService.editAngebot(this.Angebot)
        .then(response => {
          this.step = 13;

        })
        .catch(e => {
          this.step = 14;
        });
    },
    validateFields(){
      let a = this.Angebot;

      function checkTelefon(a) {
        if(a.telefon == undefined || a.telefon == ""){
          return false
        } else {
          return true
        }
      }
      function checkMobil(a) {
        if(a.mobil == undefined || a.mobil == ""){
          return false
        } else {
          return true
        }
      }

      function checkName(a){
        if(a.name == undefined || a.name == ""){
          return false
        } else {
          return true
        }
      }

      function checkEmail(a){
        if(a.email == undefined || a.email == ""){
          return false
        } else {
          return true
        }
      }


      if(!(checkTelefon(a) || checkMobil(a))){
        this.requiredErrorMessage = 1;
        return false
      }
      if(!checkName(a)){
        this.requiredErrorMessage = 2;
        return false
      }
      if(!checkEmail(a)){
        this.requiredErrorMessage = 3
        return false
      }

      return true

    },
    selectEtage(){

    },
    next(){
        if(this.step == 1){
          if(!this.validateFields()){
            this.showRequiredError = true;
            return
          } else {
            this.showRequiredError = false;
          }
        }
        if (this.step == 12){ return}
        if(this.step == 4 && this.Angebot.art === 'wohngemeinschaft'){
          this.step++;
        } else if(this.step == 4 && this.Angebot.art !== 'wohngemeinschaft'){
          this.step = 6;
        } else {
          this.step++;
        }

    },
    prev(){
        if (this.step == 1){ return}
        if(this.step == 6 && this.Angebot.art === 'wohngemeinschaft'){
          this.step--;
        } else if(this.step == 6 && this.Angebot.art !== 'wohngemeinschaft'){
          this.step = 4;
        } else {
          this.step--;
        }
    },
    changeListOrte(event) {
      this.Angebot.ort = event;
    },
    changeZimmerart(event) {
      this.Angebot.zimmerart = event;
    },
    selectZimmer(key){
      this.arten.forEach(option => {
        if(option.value.toLowerCase() == key || option.value == key){
          option.selected = true;
        } else {
          option.selected = false;
        }
      });
    },
    changeNebenkostenart(event) {
      this.Angebot.nebenkostenart = event;
    },
    selectNebenkosten(key){
      this.nebenkostenArten.forEach(option => {
        if(option.text.toLowerCase() == key || option.value == key){
          option.selected = true;
        } else {
          option.selected = false;
        }
      });
    },
    changeInternet(event) {
      this.Angebot.ausstattungsonstigesinternet = event;

    },
    selectTelefon(key){
      this.telefonListe.forEach(option => {

        if(option.text.toLowerCase() == key || option.value == key){
          option.selected = true;
        } else {
          option.selected = false;
        }
      });
    },
    selectOrt(key){
      this.listOrte.forEach(option => {
        if(option.text.toLowerCase() == key.toLowerCase() || option.value == key.toLowerCase()){
          option.selected = true;
        } else {
          option.selected = false;
        }
      });
    },
    changeTelefon(event) {
      this.Angebot.ausstattungsonstigestelefon = event;
    },
    selectInternet(key){
      this.internetListe.forEach(option => {
        if(option.text.toLowerCase() == key || option.value == key){
          option.selected = true;
        } else {
          option.selected = false;
        }
      });
    },
    addToOrte(array, index){
      let liste = this.listOrte;
      if(index == 1){
        liste.push({ text: 'Freiburger Stadtteile', value: null, disabled: true, optgroup: true });
        for(let i = 0; i < array.length; i++){
          let item = {text: array[i].SettingValue.toString(), value:array[i].SettingId, index: i};
          liste.push(item)
        }
      } else if(index == 2){
        liste.push({ text: 'Orte in der Umgebung von Freiburg', value: null, disabled: true, optgroup: true });
        for(let i = 0; i < array.length; i++){
          let item = {text: array[i].SettingValue.toString(), value:array[i].SettingId, index: i};
          liste.push(item)
        }
      }
      this.listOrte = liste;
      this.selectOrt(this.Angebot.ort);
    },
    getListFreiburg(){
      SettingService.getSettings(1)
              .then(response => {
                this.addToOrte(response.data, 1);
              })
              .catch(error => {
                console.log("There was an error:", error.response);
              });
    },
    getListUmgebung(){
      SettingService.getSettings(2)
              .then(response => {
                this.addToOrte(response.data, 2);
              })
              .catch(error => {
                console.log("There was an error:", error.response);
              });
    },
    getImages(id){
      ImageService.getImages(id).then(response => {

          let data = response.data;
          for(let i = 0; i < data.length; i++){
            data[i] = 'https://www.wohnungsdatenbank.uni-freiburg.de//storage/'+ data[i];
          }
          this.images = data;
        })
        .catch(error => {
                console.log("There was an error:", error.response);
        });
    },
    removeNullItem(){
      if(this.Angebot.showemail == "0"){
        this.Angebot.showemail = false;
      }
      if(this.Angebot.showtelefon == "0"){
        this.Angebot.showtelefon = false;
      }
      if(this.Angebot.showmobil == "0"){
        this.Angebot.showmobil = false;
      }
      if(this.Angebot.showname == "0"){
        this.Angebot.showname = false;
      }

      if(this.Angebot.showemail == "1"){
        this.Angebot.showemail = true;
      }
      if(this.Angebot.showtelefon == "1"){
        this.Angebot.showtelefon = true;
      }
      if(this.Angebot.showmobil == "1"){
        this.Angebot.showmobil = true;
      }
      if(this.Angebot.showname == "1"){
        this.Angebot.showname = true;
      }


      if(this.Angebot.verkehrsanbindung == null || this.Angebot.verkehrsanbindung == "" ){
        this.Angebot.verkehrsanbindung = [];
      }
      console.log(typeof this.Angebot.etage)
      if(typeof this.Angebot.etage === 'string' || this.Angebot.etage instanceof String ){

        let temp = this.Angebot.etage;
        this.Angebot.etage = [temp];
      }
      if(this.Angebot.etage == null || this.Angebot.etage == "" || this.Angebot.etage == false || this.Angebot.etage == 'dach'){
        this.Angebot.etage = [];
      }
      if(this.Angebot.zimmerzusatzinformationen == null || this.Angebot.zimmerzusatzinformationen == ""){
        this.Angebot.zimmerzusatzinformationen = [];
      }
      if(this.Angebot.ausstattungsonstiges == null || this.Angebot.ausstattungsonstiges == ""){
        this.Angebot.ausstattungsonstiges = [];
      }
      if(this.Angebot.ausstattungbad == null || this.Angebot.ausstattungbad == ""){
        this.Angebot.ausstattungbad = [];
      }
      if(this.Angebot.ausstattungkueche == null || this.Angebot.ausstattungkueche == ""){
        this.Angebot.ausstattungkueche = [];
      }
      if(this.Angebot.mieterbevorzugt == null || this.Angebot.mieterbevorzugt == ""){
        this.Angebot.mieterbevorzugt = [];
      }
      if(this.Angebot.lift == false){
        this.Angebot.lift = 0;
      } else {
        this.Angebot.lift = 1;
      }
    },
    keyEventHandler(e){
      var keyCode = e.keyCode;
      if(keyCode == 13){
        e.preventDefault();
        this.next();
      }
    }
  },
  computed: {
  },
  mounted: function(){

    window.addEventListener("keypress", this.keyEventHandler, false);
    //this.Angebot.mieterbevorzugt.split(',');


    this.removeNullItem()

  },
  beforeMount: function() {
    this.getListFreiburg();
    this.getListUmgebung();

    if(this.angebotToEdit){
      localStorage.removeItem("angebotToEdit");
      localStorage.setItem("angebotToEdit", JSON.stringify(this.angebotToEdit));

    } else {
      this.angebotToEdit = JSON.parse(localStorage.getItem("angebotToEdit"));
    }
    this.Angebot = this.angebotToEdit;

    if(this.Angebot.freiab != "0000-00-00 00:00:00" && this.Angebot.freiab != "30.11.0001" && this.Angebot.freiab != null){
      this.Angebot.freiab = this.$func.formateDateFromDB(this.Angebot.freiab)
    } else {
      this.Angebot.freiab = null;
      //this.Angebot.freiab = format(this.Angebot.freiab , 'DD.M.YYYY');
    }
    if(this.Angebot.freibis != "0000-00-00 00:00:00" && this.Angebot.freibis != "30.11.0001" && this.Angebot.freibis != null){

      this.Angebot.freibis = this.$func.formateDateFromDB(this.Angebot.freibis)
    } else {
      this.Angebot.freibis = null;
      //this.Angebot.freibis = format(this.Angebot.freibis , 'DD.M.YYYY');

    }
    if(this.Angebot.etage == '0' ||this.Angebot.etage == null){
      this.Angebot.etage = [];
    }



    //TODO: Datum noch anpassen so das sie zu den Options passt
    this.selectInternet(this.Angebot.ausstattungsonstigesinternet);
    this.selectTelefon(this.Angebot.ausstattungsonstigestelefon);
    this.selectNebenkosten(this.Angebot.nebenkostenart);
    this.selectZimmer(this.Angebot.zimmerart);
    //this.selectOrt(this.Angebot.ort)
    this.getImages(this.Angebot.persistence_object_identifier);

  }
  
};
</script>
<style lang="scss" scoped>
  .image{
    position: relative;
  }
  .image__preview {
    float: left;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    margin: 5px;
    position: relative;
  }
  .step{
    margin-bottom: 25px;
  }
  label{
      text-align: left;
    }
    .next-btn{
      opacity: 0;
      cursor: pointer;
      pointer-events: none;
      -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
    }
    .next-btn.active{
      opacity: 1;
      pointer-events: all;
    }
    h2{
      text-align: left;
      margin-bottom: 15px;
    }
  .close__btn{
    z-index: 10;
    position: absolute;
    right: 5px;
    top: 5px;
    color: red;
    font-size: 20px;
    padding: 10px;
  }
    
</style>

